export default __webpack_public_path__ + "static/media/6105.c4353896.svg";